import DocumentFile from './component';

export default DocumentFile;
